module.exports = __webpack_public_path__ + "static/media/PORTADA.ee54eb1d.jpg";